if (!customElements.get('sticky-atc-bar')) {
  customElements.define(
    'sticky-atc-bar',
    class StickyATCBar extends HTMLElement {
        constructor() {
            super();
            this.selectors = {
                variantIdSelect: '[name="id"]'
            };
        }

        get mainProduct() {
            return this._mainProduct || (this._mainProduct = document.querySelector("product-info[id^='MainProduct']")) || document.querySelector("product-info");
        }
        set mainProduct(val) {
            this._mainProduct = val;
        }

        get select() {
            return this.querySelector("select");
        }

        get sectionId() {
            return this.dataset.originalSection || this.dataset.section;
        }

        get quantityInput() {
            return this.querySelector('input[name="quantity"]');
        }

        get currentQuantity() {
            const input = this.quantityInput;
            return input ? (Math.max(1, parseInt(input.value) || 1)) : 1;
        }

        connectedCallback() {
            this.container = this.closest(".sticky_pro_page");
            this.mainProduct = document.querySelector("product-info[id^='MainProduct']") || document.querySelector("product-info");
            this.productFormActions = this.mainProduct ? this.mainProduct.querySelector("product-form") : null;
            this.variantData = this.getVariantData();
            this.init();

            // Initial sync with main product if already loaded
            const mainVariantInput = this.mainProduct?.querySelector('input[name="id"]');
            if (mainVariantInput && mainVariantInput.value) {
                const initialVariant = this.variantData.find(v => v.id === Number(mainVariantInput.value));
                if (initialVariant) {
                    this.currentVariant = initialVariant;
                    const variantSelect = this.querySelector(this.selectors.variantIdSelect);
                    if (variantSelect) {
                        variantSelect.value = initialVariant.id;
                    }
                    this.updatePrice(initialVariant, null, this.currentQuantity);
                }
            } else if (this.select) {
                const initialVariant = this.variantData.find(v => v.id === Number(this.select.value));
                if (initialVariant) {
                    this.currentVariant = initialVariant;
                }
            }

            // Sync when variant dropdown changes in sticky ATC
            if (this.select) {
                this.select.addEventListener("change", (e) => {
                    e.preventDefault();
                    if (this.isUpdating) return;
                    this.isUpdating = true;
                    window.__preventScrollTrigger = '0';
                    setTimeout(() => {
                        window.__preventScrollTrigger = '1';
                    }, 2000);

                    this.mainVariantSelects = this.mainProduct && this.mainProduct.querySelector("variant-selects");
                    const selectedVariantId = this.querySelector(this.selectors.variantIdSelect)?.value;
                    this.currentVariant = this.variantData.find(variant => variant.id === Number(selectedVariantId));

                    if (this.mainVariantSelects && this.currentVariant) {
                        Array.from(this.mainVariantSelects.querySelectorAll("select, fieldset")).forEach((element, index) => {
                            const variantOptionVal = this.currentVariant.options[index];
                            if (!variantOptionVal) return;
                            switch (element.tagName) {
                                case "SELECT":
                                    element.querySelectorAll("option").forEach(option => option.removeAttribute("selected"));
                                    element.value = variantOptionVal;
                                    const selectedOption = element.querySelector(`option[value="${variantOptionVal}"]`);
                                    if (selectedOption) {
                                        selectedOption.setAttribute("selected", "selected");
                                    }
                                    element.dispatchEvent(new Event("change", { bubbles: true }));
                                    break;
                                case "FIELDSET":
                                    Array.from(element.querySelectorAll("input")).forEach(radio => {
                                        if (radio.value === variantOptionVal) {
                                            radio.checked = true;
                                            radio.dispatchEvent(new Event("change", { bubbles: true }));
                                        }
                                    });
                                    break;
                            }
                        });
                        this.mainVariantSelects.dispatchEvent(new Event("change"));
                        this.isUpdating = false;
                    } else {
                        this.isUpdating = false;
                    }

                    if (this.currentVariant) {
                        this.updatePrice(this.currentVariant, null, this.currentQuantity);
                        this.updateSubmitButton(!this.currentVariant.available, window.variantStrings?.soldOut || 'Sold Out');
                    } else {
                        this.updateSubmitButton(true, "");
                    }
                });
            }

            this.initQuantityHandlers();
        }

        initQuantityHandlers() {
            const qtyInput = this.quantityInput;
            const onQtyChange = () => {
                const qty = this.currentQuantity;
                this.updatePrice(this.currentVariant, null, qty);

                // Also keep main product quantity input in sync if present
                const mainQty = this.mainProduct?.querySelector('input[name="quantity"]');
                if (mainQty && parseInt(mainQty.value) !== qty) {
                    mainQty.value = qty;
                    mainQty.dispatchEvent(new Event('change', { bubbles: true }));
                }
            };

            if (qtyInput) {
                qtyInput.addEventListener('change', onQtyChange);
                qtyInput.addEventListener('input', onQtyChange);
            }

            this.querySelectorAll('.quantity__button').forEach(btn => {
                btn.addEventListener('click', () => {
                    setTimeout(onQtyChange, 15);
                });
            });
        }

        init() {
            if (!this.productFormActions) {
                if (this.container) this.container.classList.add("sticky_padd");
                return;
            }
            this.observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    const method = entry.intersectionRatio !== 1 ? "add" : "remove";
                    if (this.container) this.container.classList[method]("sticky_padd");
                });
            }, {
                threshold: 1,
                rootMargin: '-80px 0px 0px 0px'
            });
            this.setObserveTarget();
            this.syncWithMainProductForm();
            this.observeMainPrice();
        }

        observeMainPrice() {
            const mainPriceContainer = (this.mainProduct && (this.mainProduct.querySelector('.product_main_price') || this.mainProduct.querySelector('[id^="price-"]'))) || document.querySelector('.product_main_price') || document.querySelector('[id^="price-"]');
            if (!mainPriceContainer) return;

            const copyPrice = () => {
                this.updatePrice(this.currentVariant, null, this.currentQuantity);
            };

            const priceObserver = new MutationObserver(() => {
                copyPrice();
            });
            priceObserver.observe(mainPriceContainer, { childList: true, subtree: true, characterData: true });
        }

        setObserveTarget() {
            if (this.productFormActions) {
                this.observer.observe(this.productFormActions);
                this.observeTarget = this.productFormActions;
            }
        }

        getVariantData() {
            try {
                return this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
            } catch (e) {
                return [];
            }
        }

        updateSubmitButton(disable = true, text) {
            const productForm = this.querySelector('[id^="product-form-"]') || this.querySelector('form[data-type="add-to-cart-form"]') || this.querySelector('form');
            if (!productForm) return;
            const submitButton = productForm.querySelector('[name="add"]');
            if (!submitButton) return;
            const submitButtonText = submitButton.querySelector("span") || submitButton;
            if (disable) {
                submitButton.setAttribute('disabled', 'disabled');
                if (text) submitButtonText.textContent = text;
            } else {
                submitButton.removeAttribute('disabled');
                submitButtonText.textContent = window.variantStrings?.addToCart || 'Add To Cart';
            }
        }

        formatCurrency(cents, sampleText) {
            if (cents == null) return '';
            const num = Number(cents) / 100;
            const formattedNum = num.toLocaleString('en-IN', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });

            if (sampleText) {
                const trimmed = sampleText.trim();
                const prefixMatch = trimmed.match(/^([^\d]+)/);
                if (prefixMatch) {
                    return `${prefixMatch[1].trim()} ${formattedNum}`;
                }
            }
            return `Rs. ${formattedNum}`;
        }

        updatePrice(variant, htmlSource, quantity = null) {
            if (!variant) variant = this.currentVariant;
            if (!variant && this.variantData) {
                const selectId = this.querySelector(this.selectors.variantIdSelect)?.value;
                if (selectId) {
                    variant = this.variantData.find(v => v.id === Number(selectId));
                }
            }
            if (!variant) return;

            if (quantity == null) {
                quantity = this.currentQuantity;
            }
            quantity = Math.max(1, parseInt(quantity) || 1);

            const priceContainer = this.querySelector(`#Price-${this.sectionId}`) || this.querySelector('.mainp-price');
            if (!priceContainer) return;

            const sampleEl = priceContainer.querySelector('.price-item') || document.querySelector('.product_main_price .price-item');
            const sampleText = sampleEl ? sampleEl.textContent : 'Rs. 0.00';

            const unitPrice = Number(variant.price);
            const unitCompareAt = Number(variant.compare_at_price);

            const totalPrice = unitPrice * quantity;
            const totalCompareAt = unitCompareAt ? unitCompareAt * quantity : null;
            const isSale = totalCompareAt && totalCompareAt > totalPrice;

            const formattedPrice = this.formatCurrency(totalPrice, sampleText);
            const formattedCompareAt = totalCompareAt ? this.formatCurrency(totalCompareAt, sampleText) : '';

            let percentOff = 0;
            if (isSale) {
                percentOff = Math.round(((totalCompareAt - totalPrice) * 100) / totalCompareAt);
            }

            let priceWrapper = priceContainer.querySelector('.price');
            if (!priceWrapper) {
                priceWrapper = document.createElement('div');
                priceWrapper.className = 'price';
                priceContainer.appendChild(priceWrapper);
            }

            priceWrapper.classList.remove('price--large');
            priceWrapper.classList.toggle('price--on-sale', isSale);

            let containerEl = priceWrapper.querySelector('.price__container');
            if (!containerEl) {
                priceWrapper.innerHTML = `
                    <div class="price__container">
                        <div class="price__regular">
                            <span class="visually-hidden visually-hidden--inline">Regular price</span>
                            <span class="price-item price-item--regular"></span>
                        </div>
                        <div class="price__sale">
                            <span class="visually-hidden visually-hidden--inline">Sale price</span>
                            <span class="price-item price-item--sale price-item--last"></span>
                            <span class="visually-hidden visually-hidden--inline">Regular price</span>
                            <span>
                                <s class="price-item price-item--regular"></s>
                            </span>
                            <span class="price__percent-off" style="display: none;"></span>
                        </div>
                    </div>
                `;
                containerEl = priceWrapper.querySelector('.price__container');
            }

            const regularItem = containerEl.querySelector('.price__regular .price-item--regular');
            const saleItem = containerEl.querySelector('.price__sale .price-item--sale');
            const strikeItem = containerEl.querySelector('.price__sale s.price-item--regular');
            let badgeItem = containerEl.querySelector('.price__percent-off');

            if (isSale) {
                if (saleItem) saleItem.textContent = formattedPrice;
                if (strikeItem) strikeItem.textContent = formattedCompareAt;
                if (regularItem) regularItem.textContent = formattedCompareAt;

                if (percentOff > 0) {
                    if (!badgeItem) {
                        badgeItem = document.createElement('span');
                        badgeItem.className = 'price__percent-off';
                        containerEl.querySelector('.price__sale')?.appendChild(badgeItem);
                    }
                    badgeItem.textContent = `${percentOff}% OFF`;
                    badgeItem.style.display = '';
                } else if (badgeItem) {
                    badgeItem.style.display = 'none';
                }
            } else {
                if (regularItem) regularItem.textContent = formattedPrice;
                if (saleItem) saleItem.textContent = formattedPrice;
                if (strikeItem) strikeItem.textContent = '';
                if (badgeItem) badgeItem.style.display = 'none';
            }
        }

        syncWithMainProductForm() {
            subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
                const mainProduct = this.mainProduct;
                const mainSectionId = mainProduct ? (mainProduct.dataset.originalSection || mainProduct.dataset.section || mainProduct.dataset.sectionId) : null;
                if (!mainSectionId || event.data.sectionId === mainSectionId) {
                    const variant = event.data.variant;
                    if (!variant) return;

                    this.currentVariant = variant;
                    const variantInput = this.querySelector(this.selectors.variantIdSelect);
                    if (variantInput) {
                        variantInput.value = variant.id;
                        Array.from(variantInput.options || []).forEach(option => {
                            option.selected = (Number(option.value) === Number(variant.id));
                        });
                    }

                    this.updatePrice(variant, event.data.html, this.currentQuantity);
                    this.updateSubmitButton(!this.currentVariant.available, window.variantStrings?.soldOut || 'Sold Out');
                }
            });
        }
    });
}